import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";


@Injectable()
export class PbKundenData {
  data: any;
  searchData: any;


  constructor(public http: Http, public common: CommonData
    , public userData: UserData
    ) {
      this.data = [];
      this.searchData = [];
      //this.load();
  }
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }

  load() {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        var data = JSON.stringify({
          token: this.userData.jwt
      });
      /*
        this.http.post(this.common.baseurl+'pbzonen/index',data).subscribe(res => {
          this.data = res.json().data;
          //console.log(this.data);
          resolve(this.data);
        }, error => {
          console.log('HTTP Error, no answer pbzonen-data.ts');
          console.log(error);
      });
      */
      }
    });
  }

  view(pbkunden_id) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        let params = JSON.stringify({ 
          id: pbkunden_id
          ,token: this.userData.jwt
        });            

        this.http.post(this.common.baseurl+'pbkunden/view',params).subscribe(res => {
          let data = res.json().data;
          resolve(data);
        }, error => {
          console.log('HTTP Error, no answer view pbzonen-data.ts');
          //console.log(error);
      });

      }
    });
  }  

  create(pbkunden){
    return new Promise(resolve => {
      console.log(pbkunden);
      let params = JSON.stringify({ 
        pbkunden: pbkunden
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbkunden/create',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
  }
  update(pbkunden){
    return new Promise(resolve => {
      //console.log(pbzone);
      let params = JSON.stringify({ 
        pbkunden: pbkunden
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbkunden/update',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
  }
  delete(pbkunden){
    return new Promise(resolve => {

    });
  }

  search(searchQuery: string = ''){    
    let keyword = searchQuery.toLocaleLowerCase();
    return new Promise(resolve => {
      //console.log(pbzone);
      let params = JSON.stringify({ 
        q: keyword
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbkunden/search',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){      
            this.searchData = response.data;           
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
    
  }  

  emailpresent(_email: string){    
    _email = _email.toLocaleLowerCase();
    return new Promise(resolve => {
      //console.log(pbzone);
      let params = JSON.stringify({ 
        email: _email
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbkunden/emailpresent',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){               
              resolve(response);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
    
  }    

}



// WEBPACK FOOTER //
// ./src/providers/pbkunden-data.ts